exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-card[data-v-a0c9f332]{width:50%;margin:auto;box-shadow:1px 4px 18px -1px #000}", ""]);

// exports
